import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@nano/common/alert';
import { RoutingService } from '@nano/common/routing';
import { CONFIG } from '@nano/core/config';
import { ErrorService } from '@nano/core/error';
import { L10nTranslationService } from 'angular-l10n';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { take } from 'rxjs/operators';
import { MessageTemplateExsists, StartMessageThreadRequest } from './start-message-thread';
import { StartMessageThredService } from './start-message-thread.service';
import { AuthService } from '@nano/core/auth';

@Component({
  selector: 'app-start-message-thread',
  templateUrl: './start-message-thread.component.html',
  styleUrls: ['./start-message-thread.component.less'],
  standalone: false
})
export class StartMessageThreadComponent implements OnInit {
  readonly form: UntypedFormGroup;
  readonly bankName: string;
  readonly messageSubjectLength: number;

  uploading = false;
  clientName: string;
  cardNumber: string;

  private config = inject(CONFIG);

  constructor(
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private routingService: RoutingService,
    private route: ActivatedRoute,
    private translationService: L10nTranslationService,
    private startMessageThredService: StartMessageThredService,
    private authService: AuthService,
    private errorService: ErrorService
  ) {
    this.messageSubjectLength = this.config.messageSubjectLength;
    this.form = this.formBuilder.group({
      subject: [null, [Validators.required, Validators.maxLength(this.config.messageSubjectLength)]],
      body: [null, [Validators.required, Validators.maxLength(this.config.messageBodyLength)]],
      attachmentIds: [null]
    });
    this.bankName = this.config.bankName;
    this.clientName = this.authService.userName;
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((queryParams) => {
      this.cardNumber = queryParams.cardNumber as string;
    });

    this.route.params.pipe(take(1)).subscribe((params) => {
      if (!!params && params.template && MessageTemplateExsists(params.template as string)) {
        this.form.get('subject').setValue(this.translationService.translate(`messages.template.${params.template as string}.subject`));
        this.form.get('body').setValue(
          this.translationService.translate(`messages.template.${params.template as string}.body`, {
            bankName: this.bankName,
            clientName: this.clientName,
            cardNumber: this.cardNumber
          })
        );
      }
    });
  }

  fileListUpdated(files: NzUploadFile[]): void {
    this.form.get('attachmentIds').setValue(files.map((file) => file.id as string));
  }

  fileUploading(uploading: boolean): void {
    this.uploading = uploading;
  }

  startMessageThread(): void {
    this.startMessageThredService.startMessageThread(this.form.value as StartMessageThreadRequest).subscribe({
      next: (id: string) => {
        this.routingService.navigateToMessageThreadDetails(id);
        setTimeout(() => this.alertService.alert({ type: 'success', messageType: 'key', message: 'messages.sent', autoHide: true }));
      },
      error: (error: unknown) => this.errorService.handleRequestError(error)
    });
  }

  cancel(): void {
    this.routingService.navigateToMessages();
  }
}
